import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticClass:"eva-page--obsolete"},[_c('div',{staticClass:"eva-page eva-background",class:_vm.classes},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }